<template>
  <div>
    <!-- Google map -->
    <div id="map" class="w-100" style="height: 380px"></div>

    <!-- Import from NMS modal -->
    <b-modal id="show-device-modal" size="xl" no-close-on-backdrop hide-footer>
      <template #modal-header>
        <div>
          <h5>Device: {{ selectedDevice.device_name }}</h5>
        </div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="closeDeviceModal"
          >
            Close
          </button>
        </div>
      </template>
      <div class="row">
        <div class="col-3" style="font-size: 12px">
          <b-list-group>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Device ID: {{ selectedDevice.device_id }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Device Name: {{ selectedDevice.device_name }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Device Status:
              {{ selectedDevice.status === true ? "Online" : "Offline" }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Device Location: {{ selectedDevice.device_location }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Device Type: {{ selectedDevice.device_type }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              IP Address: {{ selectedDevice.device_ip }}
            </b-list-group-item>
            <b-list-group-item
              class="d-flex justify-content-between align-items-center"
            >
              Port: {{ selectedDevice.device_port }}
            </b-list-group-item>
          </b-list-group>
          <hr />
          <button
            @click="openFullscreen"
            class="btn btn-primary btn-block w-100"
          >
            Fullscreen
          </button>
          <!-- <button class="btn btn-success btn-block w-100 mt-2">
            PTZ Button
          </button> -->
        </div>
        <div class="col-9">
          <canvas id="canvas" style="width: 100%; height: auto"></canvas>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import gisMixin from "../../../mixins/gis";
import { Loader } from "@googlemaps/js-api-loader";
import { RTSP_BASE_URL } from "../../../constants/config";

export default {
  data() {
    return {
      map: null,
      selectedDevice: {},
      activeCams: [],
      isMapLoaded: false,
    };
  },

  mixins: [gisMixin],

  async mounted() {
    this.loadMyMap();

    this.sockets.subscribe("CAMERA_DEVICE", (data) => {
      this.activeCams.push(data.port);
      new JSMpeg.Player(`${RTSP_BASE_URL}:${data.port}`, {
        canvas: document.getElementById("canvas"),
      });
    });
  },

  computed: {
    gisDevices() {
      return this.$store.getters["gis/devices"];
    },
    location() {
      return this.$store.getters["gis/location"]
    },
  },

  watch: {
    location: function () {
      if (this.location && !this.isMapLoaded) {
        this.loadMyMap();
        this.isMapLoaded = true;
      }
    },
  },

  methods: {
    closeDeviceModal() {
      this.$bvModal.hide("show-device-modal");
      for (let cam of this.activeCams) {
        this.$socket.emit(
          "REQUEST:CAMERA_DEVICE",
          JSON.stringify({ command: "stop", id: cam })
        );
      }
    },

    openFullscreen() {
      var elem = document.getElementById("canvas");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    },

    closeFullscreen() {
      try {
        if (document) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async loadMyMap() {
      if (this.location && !this.isMapLoaded) {
        this.isMapLoaded = true;
        const loader = new Loader({
          apiKey: "AIzaSyAsjTYlNYOvHXj8GV72iYJjxbit6eMGt1U",
          version: "weekly",
        });

        // const lat = parseFloat(this.location.centerLatitude).toFixed(3);
        // const long = parseFloat(this.location.centerLongitude).toFixed(3);

        loader
          .load()
          .then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
              center: {
                lat: 28.79515549252772,
                lng: 76.00988477392694,
              },
              zoom: 10,
              streetViewControl: false,
              mapTypeControl: false,
              styles: [
                {
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "administrative.country",
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "off",
                    },
                  ],
                },
                {
                  featureType: "road",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  stylers: [{ hue: "#00ffe6" }, { saturation: -20 }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ lightness: 100 }, { visibility: "simplified" }],
                },
                {
                  featureType: "road",
                  elementType: "labels",
                  stylers: [{ visibility: "off" }],
                },
                // { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                // {
                //   elementType: "labels.text.stroke",
                //   stylers: [{ color: "#242f3e" }],
                // },
                // {
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#746855" }],
                // },
                // {
                //   featureType: "administrative.locality",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#d59563" }],
                // },
                // {
                //   featureType: "poi",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#d59563" }],
                // },
                // {
                //   featureType: "poi.park",
                //   elementType: "geometry",
                //   stylers: [{ color: "#263c3f" }],
                // },
                // {
                //   featureType: "poi.park",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#6b9a76" }],
                // },
                // {
                //   featureType: "road",
                //   elementType: "geometry",
                //   stylers: [{ color: "#38414e" }],
                // },
                // {
                //   featureType: "road",
                //   elementType: "geometry.stroke",
                //   stylers: [{ color: "#212a37" }],
                // },
                // {
                //   featureType: "road",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#9ca5b3" }],
                // },
                // {
                //   featureType: "road.highway",
                //   elementType: "geometry",
                //   stylers: [{ color: "#746855" }],
                // },
                // {
                //   featureType: "road.highway",
                //   elementType: "geometry.stroke",
                //   stylers: [{ color: "#1f2835" }],
                // },
                // {
                //   featureType: "road.highway",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#f3d19c" }],
                // },
                // {
                //   featureType: "transit",
                //   elementType: "geometry",
                //   stylers: [{ color: "#2f3948" }],
                // },
                // {
                //   featureType: "transit.station",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#d59563" }],
                // },
                // {
                //   featureType: "water",
                //   elementType: "geometry",
                //   stylers: [{ color: "#17263c" }],
                // },
                // {
                //   featureType: "water",
                //   elementType: "labels.text.fill",
                //   stylers: [{ color: "#515c6d" }],
                // },
                // {
                //   featureType: "water",
                //   elementType: "labels.text.stroke",
                //   stylers: [{ color: "#17263c" }],
                // },
              ],
            });

            // this.loadRoute();
            // this.loadDevices();

            const trafficLayer = new google.maps.TrafficLayer();
            trafficLayer.setMap(this.map);
          })
          .catch((e) => {
            console.error(e);
            this.isMapLoaded = false;
          });
      }
    },

    loadDevices() {
      if (this.gisDevices.length > 0 && this.map) {
        let side = "LHS";
        for (let index in this.gisDevices) {
          let markerImage = "anpr.png";
          if (String(this.gisDevices[index].device_type).includes("ANPR"))
            markerImage = "anpr.png";
          if (String(this.gisDevices[index].device_type).includes("AVC"))
            markerImage = "avc.png";
          if (String(this.gisDevices[index].device_type).includes("VMS"))
            markerImage = "vms.png";
          if (String(this.gisDevices[index].device_type).includes("ECB"))
            markerImage = "ecb.png";
          if (String(this.gisDevices[index].device_type).includes("SWITCH"))
            markerImage = "switch.png";

          if (this.gisDevices[index].lat && this.gisDevices[index].long) {
            // if (side === "LHS") {
            //   side = "RHS";
            //   this.drawPolyline(
            //     this.gisDevices[index].lat,
            //     this.gisDevices[index].long,
            //     parseFloat(this.gisDevices[index].lat),
            //     parseFloat(this.gisDevices[index].long) - 0.04
            //   );
            // } else {
            //   side = "LHS";
            //   this.drawPolyline(
            //     this.gisDevices[index].lat,
            //     this.gisDevices[index].long,
            //     parseFloat(this.gisDevices[index].lat),
            //     parseFloat(this.gisDevices[index].long) + 0.04
            //   );
            // }

            const marker = new google.maps.Marker({
              position: {
                lat: parseFloat(this.gisDevices[index].lat),
                lng: parseFloat(this.gisDevices[index].long),
              },
              map: this.map,
              icon: {
                url: markerImage,
                scaledSize: new google.maps.Size(30, 30), // scaled size
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 0),
              },
            });

            google.maps.event.addListener(marker, "click", () => {
              this.selectedDevice = this.gisDevices[index];
              this.$bvModal.show("show-device-modal");
              this.closeFullscreen();

              this.$socket.emit(
                "REQUEST:CAMERA_DEVICE",
                JSON.stringify({
                  url: `rtsp://admin:Tyco_1234@${this.selectedDevice.device_ip}:554/Streaming/Channels/101`,
                  command: "start",
                })
              );
            });
          }
        }
      }
    },

    loadRoute() {
      if (this.location) {
        var start = new google.maps.LatLng(
          parseFloat(this.location.startLatitude),
          parseFloat(this.location.startLongitude)
        );
        var end = new google.maps.LatLng(
          parseFloat(this.location.endLatitude),
          parseFloat(this.location.endLongitude)
        );

        var directionsDisplay = new google.maps.DirectionsRenderer(); // also, constructor can get "DirectionsRendererOptions" object
        directionsDisplay.setMap(this.map); // map should be already initialized.
        directionsDisplay.setOptions({
          polylineOptions: {
            strokeColor: "#0275d8",
            strokeOpacity: 0.8,
            strokeWeight: 8,
          },
        });

        var request = {
          origin: start,
          destination: end,
          travelMode: google.maps.TravelMode.DRIVING,
        };

        var directionsService = new google.maps.DirectionsService();
        directionsService.route(request, function (response, status) {
          if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);

            // console.log(response);
            // for (let path of response.routes[0].overview_path) {
            //   console.log(path.lat());
            // }
          }
        });
      }
    },

    drawPolyline(startLat, startLong, endLat, endLong) {
      var coordinates = [
        { lat: parseFloat(startLat), lng: parseFloat(startLong) },
        { lat: parseFloat(endLat), lng: parseFloat(endLong) },
      ];

      new google.maps.Polyline({
        map: this.map,
        path: coordinates,
        geodesic: true,
        strokeColor: "#000",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });
    },
  },
};
</script>

<style scoped>
#map {
  /* width: 50%; */
  height: 50vh;
  margin: 0;
  padding: 0;
  border-radius: 5px;
}

#direction {
  color: #000;
  max-width: 99%;
  width: 300px;
  position: absolute;
  z-index: 999;
  font-size: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  outline: none !important;
  top: 55px;
  border-radius: 10px;
  margin: 2px 4px;
}

#mLogo0 {
  display: none !important;
}

.map-default {
  position: absolute;
  left: 1.5%;
  top: 3%;
}
</style>
